import { removeUndefined } from '@helpers/object';

/**
 * Config overrides for local dev.
 * Any settings not specified here will be inherited from the base config.
 */
export const localConfig = removeUndefined({
  apiUrl: 'http://127.0.0.1:8000',
  googleTagManager: {
    gtmId: 'GTM-TBS9MXD',
    auth: 'jLLWHqXGjO5Bl1AeDGL5uA',
    preview: 'env-17',
  },
});
